module.exports = __webpack_public_path__ + "img/votes_icon2.468ae426.png";